export const Device = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
      <path d="M8.33398 10V11.3333L9.66732 12V12.6667H4.33398L4.33158 12.0024L5.66732 11.3333V10H0.995184C0.630018 10 0.333984 9.70073 0.333984 9.32833V0.671653C0.333984 0.300713 0.637524 0 0.995184 0H13.0061C13.3713 0 13.6673 0.29928 13.6673 0.671653V9.32833C13.6673 9.69927 13.3638 10 13.0061 10H8.33398ZM1.66732 1.33333V7.33333H12.334V1.33333H1.66732Z" fill="#E6F7FF"/>
    </svg>
  )
}
